import { Link } from 'react-router-dom';
import { ArrowLeft, Building2, CheckCircle2, LockKeyhole, UsersRound } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { businessContent } from '../lib/marketingContent';

const statusItems = [
  'Profil complete',
  'Dossier commence',
  'Document manquant',
  'Demarche terminee',
  'Action requise',
  'Montant potentiel detecte en agrege',
];

const plans = [
  ['Starter', '99€/mois', 'Pour ecoles, associations et petites equipes.'],
  ['Business', '299€/mois', 'Pour entreprises, mutuelles et plateformes.'],
  ['Scale / Cabinet', 'Sur devis', 'Pour cabinets, banques et grands volumes.'],
];

export const BusinessPage = () => {
  const { isDark } = useTheme();

  return (
    <div className={`min-h-screen ${isDark ? 'bg-[#0F0F1A] text-white' : 'bg-[#F8F7F4] text-[#1d1d1f]'}`}>
      <main className="max-w-6xl mx-auto px-6 py-8 md:py-12">
        <Link to="/" className={`inline-flex items-center gap-2 mb-12 text-sm ${isDark ? 'text-[#94A3B8]' : 'text-gray-600'}`}>
          <ArrowLeft size={17} />
          Retour a Skipya
        </Link>

        <section className="grid lg:grid-cols-[1.1fr_0.9fr] gap-10 items-center mb-20">
          <div>
            <p className="text-[#81d8d0] text-sm font-semibold mb-4">Skipya Business</p>
            <h1 className="text-4xl md:text-6xl font-semibold tracking-tight leading-tight mb-6">
              Accompagnez vos publics sans multiplier les relances manuelles.
            </h1>
            <p className={`text-lg leading-8 mb-8 ${isDark ? 'text-[#94A3B8]' : 'text-gray-600'}`}>
              {businessContent.promise}
            </p>
            <a href="mailto:gilleskorzec@gmail.com?subject=Skipya%20Business" className="btn-apple btn-apple-primary">
              Demander une demo
            </a>
          </div>

          <div className={`rounded-3xl border p-6 ${isDark ? 'bg-white/5 border-white/10' : 'bg-white border-gray-200 shadow-xl'}`}>
            <div className="grid grid-cols-2 gap-3 mb-6">
              {[
                [Building2, 'Portail personnalise'],
                [UsersRound, 'Invitations utilisateurs'],
                [CheckCircle2, 'Suivi de progression'],
                [LockKeyhole, 'Consentement et confidentialite'],
              ].map(([Icon, label]) => (
                <div key={label} className={`rounded-2xl p-4 ${isDark ? 'bg-black/30' : 'bg-[#F8F7F4]'}`}>
                  <Icon size={22} className="text-[#81d8d0] mb-3" />
                  <p className="text-sm font-medium">{label}</p>
                </div>
              ))}
            </div>
            <p className={`text-sm leading-6 ${isDark ? 'text-[#94A3B8]' : 'text-gray-600'}`}>
              L'organisation voit des statuts et agregats. Les donnees fiscales et personnelles detaillees restent privees par defaut.
            </p>
          </div>
        </section>

        <section className="mb-20">
          <h2 className="text-3xl font-semibold tracking-tight mb-6">Ce que voit une organisation</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {statusItems.map((item) => (
              <div key={item} className={`rounded-2xl border p-4 ${isDark ? 'bg-white/5 border-white/10' : 'bg-white border-gray-200'}`}>
                <CheckCircle2 size={18} className="text-[#81d8d0] mb-2" />
                <p className="text-sm font-medium">{item}</p>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h2 className="text-3xl font-semibold tracking-tight mb-6">Offres indicatives</h2>
          <div className="grid md:grid-cols-3 gap-4">
            {plans.map(([name, price, description]) => (
              <div key={name} className={`rounded-3xl border p-6 ${isDark ? 'bg-white/5 border-white/10' : 'bg-white border-gray-200'}`}>
                <h3 className="text-xl font-semibold mb-2">{name}</h3>
                <p className="text-3xl font-semibold text-[#81d8d0] mb-4">{price}</p>
                <p className={`text-sm leading-6 ${isDark ? 'text-[#94A3B8]' : 'text-gray-600'}`}>{description}</p>
              </div>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default BusinessPage;
